import { render } from "./invite_form.vue?vue&type=template&id=88f883a2"
import script from "./invite_form.vue?vue&type=script&lang=js"
export * from "./invite_form.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__